module.exports = __webpack_public_path__ + "img/livesession_grey.3b9379c3.svg";